export enum DistributorCode {
  VY = 'VY',
  HM = 'HM',
}
